<template>
<div class="layer-project" data-project-name="hyundai-steel"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit"><span class="award12"></span>Hyundai Steel</h1>
                <a href="http://www.hyundai-steel.com" class="link" target="_blank">www.hyundai-steel.com</a>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">현대제철은 국내 최초의 철강회사로 전기로 사업의 바탕 위에 고로 사업을 새로운 성장 동력으로 삼아 지속적 성장을 하고 있는 기업입니다. <span>역동적인 현대제철을 표현하기 위해 영상 및 사진 등의 요소를 적극적으로 활용하였고, 인재 채용 메뉴를 강화하여 입사를 지원하는 사용자를 위한 구성을 했습니다.</span></p>
                <div class="project-overview-diagram">
                    <p class="diagram01">Value of Expertise <span>&amp; Pride of Excellence</span></p>
                    <p class="diagram02">
                        <ul>
                            <li class="item01">Sustain<span>ability</span></li>
                            <li class="item02">Creative</li>
                            <li class="item03">HYUNDAI <br>STEEL</li>
                        </ul>
                    </p>
                    <p class="diagram03">Core-biz. &amp; Tech</p>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="section full section01">
            <div class="inner-section">
                <div class="pc-web-info">
                    <strong class="project-subtit">PC Web</strong>
                    <p class="pc-web-text">Full Page 구성으로 주요 콘텐츠를 메인 페이지에 노출하여 사용성을 높인 구조로 구성했습니다. 
                    <br>현대제철을 이미지를 상단 영상으로 전달하고 전체 주요 메뉴를 영상 위에 노출함으로써 주요 콘텐츠로의 이동이 용이하도록 했습니다.</p>
                </div>
                <section class="pc-web-wrap">
                    <div class="pc-web swiper-container">
                        <ul class="swiper-wrapper">
                            <li class="swiper-slide">
                                <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-img01@m.png">
                            </li>
                            <li class="swiper-slide">
                                <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-img02@m.png">
                            </li>
                            <li class="swiper-slide">
                                <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-img03@m.png">
                            </li>
                            <li class="swiper-slide">
                                <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-img04@m.png">
                            </li>
                            <li class="swiper-slide">
                                <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-img05@m.png">
                            </li>
                        </ul>
                        
                        <!-- Add Pagination -->
                        <div class="swiper-pagination pc-web-pagination"></div>
                    </div>
                </section>
            </div>
        </section>
        <section class="section full pc-web-sub-wrap">
            <div class="pc-web-sub swiper-container">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-sub-img01@m.png">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-sub-img02@m.png">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-sub-img03@m.png">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/pc-web-sub-img04@m.png">
                    </li>
                </ul>
                
                <!-- Add Pagination -->
                <div class="swiper-pagination pc-web-sub-pagination"></div>
            </div>
        </section>

        <section class="section section02">
            <div class="inner-section">
                <strong class="project-subtit">Mobile Web</strong>
                <div class="mobile-img">
                    <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/mobile-img@m.png">
                </div>
            </div>
        </section>
        
        <section class="section full section03">
            <div class="inner-section">
                <div class="point-color-area">
                    <ul>
                        <li class="item01">
                            <span class="color-title">Main Color</span>
                            <p class="color-text">#475976</p>
                        </li>
                        <li class="item02">
                            <span class="color-title">Main Color</span>
                            <p class="color-text">#0075dc</p>
                        </li>
                        <li class="item03">
                            <span class="color-title">Main Color</span>
                            <p class="color-text">#549fde</p>
                        </li>
                        <li class="item04">
                            <span class="color-title">Sub Color</span>
                            <p class="color-text">#9da2a6</p>
                        </li>
                        <li class="item05">
                            <span class="color-title">Sub Color</span>
                            <p class="color-text">#333333</p>
                        </li>
                    </ul>
                </div>
                <div class="point-icon-area">
                    <ul>
                        <li class="item01"><img src="/static/img/project-detail/hyundai-steel/util-icon01@m.png" alt=""></li>
                        <li class="item02"><img src="/static/img/project-detail/hyundai-steel/util-icon02@m.png" alt=""></li>
                        <li class="item03"><img src="/static/img/project-detail/hyundai-steel/util-icon03@m.png" alt=""></li>
                        <li class="item04"><img src="/static/img/project-detail/hyundai-steel/util-icon04@m.png" alt=""></li>
                        <li class="item05"><img src="/static/img/project-detail/hyundai-steel/util-icon05@m.png" alt=""></li>
                        <li class="item06"><img src="/static/img/project-detail/hyundai-steel/util-icon06@m.png" alt=""></li>
                        <li class="item07"><img src="/static/img/project-detail/hyundai-steel/util-icon07@m.png" alt=""></li>
                    </ul>
                </div>
                <div class="point-font-area clfix">
                    <div class="point-font-title">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/hyundai-font-title@m.png">
                    </div>
                    <div class="point-font-text">
                        <img src="" alt="" data-src="/static/img/project-detail/hyundai-steel/hyundai-font-text@m.png">
                    </div>
                </div>
            </div>
        </section>

        <section class="project-client"><strong class="a11y-hidden">HYUNDAI STEEL</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var pcSwiper = new Swiper(".pc-web", {
			slidesPerView: "auto",
			spaceBetween: 120,
			loop: true,
			pagination: {
				el: ".pc-web-pagination",
				clickable: true,
			},
			breakpoints: {
				// when window width is <= 712px
				711: {
					spaceBetween: 15,
				},
				1279: {
					spaceBetween: 40,
				},
			},
		});

		var subSwiper = new Swiper(".pc-web-sub", {
			slidesPerView: "auto",
			spaceBetween: 26,
			loop: true,
			pagination: {
				el: ".pc-web-sub-pagination",
				clickable: true,
			},
			breakpoints: {
				// when window width is <= 712px
				1279: {
					spaceBetween: 15,
				},
			},
		});
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
.section {
	background-color: #e6e6e6;
}
.project-tit {
	text-transform: uppercase;
}
.project-subtit {
	margin-bottom: 20px;
	font-size: 2rem;
}
@media screen and (min-width: 712px) {
	.project-subtit {
		margin-bottom: 10px;
		font-size: 3.3rem;
	}
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/hyundai-steel/ci.png) 50% / auto
		39px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hyundai-steel/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hyundai-steel/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 44px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hyundai-steel/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 88px;
	}
}

/* Overview */
.project-overview {
	background-color: #0b3985;
	color: #fff;
}
.project-overview-diagram {
	padding-top: 30px;
	text-align: center;
}
.project-overview-diagram .diagram01:after {
	content: "";
	display: block;
	width: 1px;
	height: 20px;
	margin: 15px auto;
	background-color: #fff;
}
.project-overview-diagram .diagram02 ul {
	display: flex;
	justify-content: center;
}
.project-overview-diagram .diagram02 ul:after {
	content: "";
	display: block;
	clear: both;
}
.project-overview-diagram .diagram02 li {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	flex-direction: column;
	width: 93px;
	height: 93px;
	line-height: 1.7rem;
	border-radius: 50%;
}
.project-overview-diagram .diagram02 .item01,
.project-overview-diagram .diagram02 .item02 {
	border: 1px solid #fff;
}
.project-overview-diagram .diagram02 .item02 {
	position: relative;
	margin-left: -9px;
	margin-right: 19px;
}
.project-overview-diagram .diagram02 .item02:after {
	content: "";
	display: block;
	position: absolute;
	top: 50%;
	right: -13px;
	width: 13px;
	height: 13px;
	border-right: 1px solid #fff;
	border-bottom: 1px solid #fff;
	transform: translateY(-50%) rotate(-45deg);
}
.project-overview-diagram .diagram02 .item03 {
	background-color: #002871;
}
.project-overview-diagram .diagram03:before {
	content: "";
	display: block;
	width: 1px;
	height: 20px;
	margin: 12px auto;
	background-color: #fff;
}

@media screen and (max-width: 711px) {
	.project-overview-diagram .diagram02 .item01 span:before {
		content: "-";
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		padding-top: 37px;
	}
	.project-overview-diagram .diagram01:after {
		margin-bottom: 15px;
	}
	.project-overview-diagram .diagram02 li {
		width: 107px;
		height: 107px;
		line-height: 1.7rem;
	}
	.project-overview-diagram .diagram02 .item01 {
		flex-direction: row;
	}
	.project-overview-diagram .diagram02 .item02 {
		margin-left: -10px;
		margin-right: 32px;
	}
	.project-overview-diagram .diagram02 .item02:after {
		right: -20px;
		width: 15px;
		height: 15px;
	}
	.project-overview-diagram .diagram02 .item03 {
		padding: 10px;
	}
	.project-overview-diagram .diagram03:after {
		margin-top: 15px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-txt {
		font-size: 15px;
		line-height: 28px;
	}
	.project-overview-txt span {
		display: inline-block;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.project-overview-diagram p {
		position: relative;
		font-size: 1.8rem;
	}
	.project-overview-diagram .diagram01 {
		width: 285px;
		margin-right: 17px;
		padding-right: 100px;
	}
	.project-overview-diagram .diagram01:after {
		position: absolute;
		top: 50%;
		right: 0;
		width: 76px;
		height: 2px;
		margin: 0;
	}
	.project-overview-diagram .diagram01 span {
		display: inline-block;
	}
	.project-overview-diagram .diagram02 li {
		font-size: 2rem;
		width: 214px;
		height: 214px;
	}
	.project-overview-diagram .diagram02 .item01,
	.project-overview-diagram .diagram02 .item02 {
		border-width: 2px;
	}
	.project-overview-diagram .diagram02 .item02 {
		margin-left: -21px;
		margin-right: 42px;
	}
	.project-overview-diagram .diagram02 .item02:after {
		right: -30px;
		width: 30px;
		height: 30px;
		border-width: 2px;
	}
	.project-overview-diagram .diagram02 .item03 {
		padding: 20px;
		font-size: 2.8rem;
		line-height: 3.6rem;
	}
	.project-overview-diagram .diagram03 {
		width: 270px;
		margin-left: 17px;
		padding-left: 98px;
	}
	.project-overview-diagram .diagram03:before {
		position: absolute;
		top: 50%;
		left: 0;
		width: 76px;
		height: 2px;
		margin: 0;
	}
}

/* pc web */
.layer-project-detail > section.section01 {
	padding-bottom: 0;
}
.section01 {
	background: #e6e6e6
		url(/static/img/project-detail/hyundai-steel/pc-web-bg@m.jpg) 50% 0
		no-repeat;
	background-size: 100% auto;
	color: #fff;
}
.pc-web-info {
	margin-bottom: 30px;
	padding: 0 15px;
}
.pc-web-text {
	word-break: keep-all;
}

.pc-web {
	padding-bottom: 60px;
}
.pc-web img {
	box-shadow: 0 18px 48px rgba(0, 0, 0, 0.5);
}
.pc-web-sub img {
	box-shadow: 0 35px 30px rgba(0, 0, 0, 0.1);
}

.layer-project-detail > section.pc-web-sub-wrap {
	padding: 0;
}
.pc-web-sub {
	padding-top: 20px;
	padding-bottom: 80px;
}

.section .swiper-pagination {
	bottom: 40px;
}
.section .pc-web .swiper-pagination {
	bottom: 20px;
}

@media screen and (max-width: 711px) {
	.pc-web {
		overflow: visible;
		padding-left: 15px;
		padding-right: 15px;
	}
	.pc-web-sub {
		padding-left: 15px;
		padding-right: 15px;
	}
}
@media screen and (min-width: 712px) {
	.section01 {
		background-image: url(/static/img/project-detail/hyundai-steel/pc-web-bg@t.jpg);
	}
	.section01 .inner-section {
		padding-top: 120px;
	}
	.pc-web-info {
		padding: 0 40px;
	}
	.pc-web {
		padding-left: 40px;
		padding-right: 40px;
	}
	.pc-web-sub {
		padding-left: 40px;
		padding-right: 40px;
	}
	.pc-web-sub li {
		width: 43.4691vw;
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		background-image: url(/static/img/project-detail/hyundai-steel/pc-web-bg@w.jpg);
	}
	.section01 .inner-section {
		max-width: 1920px;
	}
	.pc-web-info {
		max-width: 1280px;
		margin: 0 auto 30px;
		padding: 0 20px;
	}
	.pc-web {
		padding-bottom: 86px;
	}
	.pc-web {
		padding-left: 0;
		padding-right: 0;
	}
	.pc-web li {
		text-align: center;
	}
	.pc-web-sub {
		padding-top: 94px;
		padding-bottom: 104px;
	}
	.pc-web-sub {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 0;
		padding-right: 0;
		overflow: visible;
	}
	.pc-web-sub li {
		width: 628px;
	}
}

/* mobile web */
.layer-project-detail > section.section02 {
	padding-top: 0;
	padding-right: 0;
	padding-bottom: 50px;
}
.section02 .inner-section {
	position: relative;
}
.section02 .project-subtit {
	position: absolute;
	top: 0;
	left: 0;
}

@media screen and (min-width: 712px) {
	.section02 .mobile-title {
		font-size: 3.3rem;
	}
	.section02 .mobile-img img {
		max-width: 92.6966vw;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section02 {
		padding-top: 80px;
		padding-left: 0;
	}
	.section02 .project-subtit {
		left: 20px;
		font-size: 56px;
	}
	.section02 .mobile-img img {
		max-width: none;
	}
}

.layer-project-detail > section.section03 {
	padding-top: 60px;
	padding-bottom: 30px;
}
.section03 {
	position: relative;
	background: url(/static/img/project-detail/hyundai-steel/util-bg@m.png) 0 50%
		no-repeat;
	background-size: cover;
}
.section03:before {
	content: "";
	position: absolute;
	top: -20px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}

.point-color-area {
	padding-bottom: 20px;
}
.point-color-area ul {
	text-align: center;
	font-size: 0;
}
.point-color-area li {
	display: inline-block;
	position: relative;
	width: 90px;
	margin: 0 5px 10px;
	padding: 90px 5px 13px;
	font-size: 1.4rem;
	background-color: #fff;
	box-shadow: 0 5px 8px rgba(0, 0, 0, 0.17);
}
.point-color-area li:before {
	content: "";
	position: absolute;
	top: 5px;
	left: 5px;
	width: 80px;
	height: 80px;
	background-color: #475976;
}
.point-color-area .item01:before {
	background-color: #475976;
}
.point-color-area .item02:before {
	background-color: #0075dc;
}
.point-color-area .item03:before {
	background-color: #549fde;
}
.point-color-area .item04:before {
	background-color: #9da2a6;
}
.point-color-area .item05:before {
	background-color: #333333;
}
.point-color-area li .color-title {
	font-size: 1.2rem;
	font-weight: 700;
	color: #444;
	text-transform: uppercase;
	line-height: 1;
}
.point-color-area li .color-text {
	color: #000;
	line-height: 1;
}

.point-icon-area ul {
	text-align: center;
	font-size: 0;
}
.point-icon-area li {
	display: inline-block;
	width: 53px;
	margin-left: 13px;
	margin-right: 13px;
	margin-bottom: 27px;
}

.point-font-area {
	margin-left: 15px;
	margin-right: 15px;
	padding-top: 30px;
	border-top: 1px solid #7d91ad;
}
.point-font-area .point-font-title {
	margin-bottom: 20px;
}
.point-font-area .point-font-title img {
	max-width: 26.40625vw;
}
.point-font-area .point-font-text img {
	max-width: 76.40625vw;
}

@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section03 {
		padding-top: 80px;
		padding-bottom: 35px;
	}
	.section03 {
		background-image: url(/static/img/project-detail/hyundai-steel/util-bg@t.png);
	}
	.section03:before {
		top: -40px;
		height: 80px;
	}
	.point-color-area li {
		width: 95px;
		margin-left: 8px;
		margin-right: 8px;
		padding: 96px 4px 25px;
	}
	.point-color-area li:before {
		top: 4px;
		width: 85px;
	}
	.point-icon-area li {
		width: 54px;
		margin-left: 13px;
		margin-right: 13px;
		margin-bottom: 30px;
	}

	.point-font-area {
		width: 540px;
		margin: 0 auto;
		padding-top: 0;
		border-top: 0;
	}
	.point-font-area > div {
		float: left;
	}
	.point-font-area .point-font-title {
		margin-right: 60px;
	}
	.point-font-area .point-font-title img {
		max-width: 125.5px;
	}
	.point-font-area .point-font-text img {
		max-width: 314px;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section03 {
		padding-top: 200px;
		padding-bottom: 200px;
	}
	.section03 {
		background-image: url(/static/img/project-detail/hyundai-steel/util-bg@w.png);
	}
	.section03:before {
		top: -98px;
		height: 196px;
	}
	.point-color-area {
		padding-bottom: 72px;
	}
	.point-color-area li {
		width: 140px;
		margin-left: 47px;
		margin-right: 47px;
		padding: 150px 7px 15px;
	}
	.point-color-area li:before {
		top: 7px;
		left: 7px;
		width: 126px;
		height: 126px;
	}
	.point-color-area li .color-title {
		display: block;
		margin-bottom: 8px;
		font-size: 1.4rem;
	}
	.point-color-area li .color-text {
		font-size: 1.8rem;
	}
	.point-icon-area li {
		width: 109px;
		margin-left: 27px;
		margin-right: 27px;
		margin-bottom: 58px;
	}
	.point-font-area {
		width: 1082px;
	}
	.point-font-area .point-font-title {
		margin-right: 121px;
	}
	.point-font-area .point-font-title img,
	.point-font-area .point-font-text img {
		max-width: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/hyundai-steel.vue